import Translate from "utils/Translate";
import React, { useContext } from 'react'
import ArrowRightAlt from 'components/icons/ArrowRightAlt';
import {createUseStyles} from 'react-jss'
import { AppContext } from 'contexts/AppContext';
import CircularIndeterminate from "components/blocks/progressBar/progressBar";

const jss = createUseStyles({
    buttonMedium1: {
        backgroundColor: (styleGuide) => styleGuide.color16,
        color: (styleGuide) => styleGuide.color1,
        borderRadius: (styleGuide) => styleGuide.buttonBorderRadius,
        height: (styleGuide) => styleGuide.buttonMediumHeight,
        fontSize: (styleGuide) => styleGuide.buttonMediumFontSize,
        fontFamily: (styleGuide) => styleGuide.secondaryFontFamily,
        lineHeight: (styleGuide) => styleGuide.buttonMediumLineHeight,
        fontWeight: '600',
        border: 'none',
        padding: '9px 20px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        
        '&:hover':{
            backgroundColor: (styleGuide) => styleGuide.color17,
        },
        
        '&:disabled':{
            backgroundColor: (styleGuide) => styleGuide.color16,
            opacity: 0.7,
            cursor: 'not-allowed'
        }
    }
})

const ButtonMedium1 = (props) => {
    const { styleGuide } = useContext(AppContext)
    const classes = jss(styleGuide)
    const showIcon = (typeof props.showIcon === 'boolean') ? props.showIcon : true
    
    return (
        <button
            title={props.title || ""}
            onClick={props.onClick}
            style={{ ...props.style }}
            disabled={props.disabled}
            className={classes.buttonMedium1}
        >
            {props.loading && !showIcon
                ? <CircularIndeterminate style={{ margin: 'auto' }} size={16} color={styleGuide.color1} />
                : props.configuredLabel
                    ? <span>{props.configuredLabel}</span>
                    : <Translate translationKey={props.translationKey}>{props.fallbackText || props.children}</Translate>
            }

            {showIcon 
                ? props.loading
                    ? <CircularIndeterminate style={{ marginLeft:'64px' }} size={16} color={styleGuide.color1} />
                    : props.icon || <ArrowRightAlt style={{ marginLeft:'64px' }}  fill={styleGuide.color1} />
                :   null
            }
        </button>
    )
}

export default ButtonMedium1;